import { useEffect, useState } from 'react';
import { useCurrentSite } from '@hotjar/site';
import { isEmpty } from 'lodash-es';
import type { FirstRecordingsData } from './useFirstRecordingStatus';
import { useFirstRecordingStatus } from './useFirstRecordingStatus';

interface UseFirstRecordingStatusWithPolling {
  firstRecordingStatus: FirstRecordingsData | undefined;
  isLoading: boolean;
}
interface IsEnabled {
  [key: number]: boolean;
}

export const useFirstRecordingStatusWithPolling = (
  isInRecordingsPage?: boolean,
): UseFirstRecordingStatusWithPolling => {
  const [isEnabled, setIsEnabled] = useState<IsEnabled>({});
  const { data: currentSite } = useCurrentSite();
  const { data: firstRecordingStatus, isLoading } = useFirstRecordingStatus({
    isIntervalEnabled: currentSite?.id ? isEnabled[currentSite.id] : false,
  });

  useEffect(() => {
    if (!currentSite || !firstRecordingStatus) {
      return setIsEnabled((prevIsEnabled) => (isEmpty(prevIsEnabled) ? prevIsEnabled : {}));
    }

    if (firstRecordingStatus?.notification_sent) {
      return setIsEnabled((prevIsEnabled) => ({ ...prevIsEnabled, [currentSite.id]: false }));
    }

    if (
      firstRecordingStatus?.recording_mode !== 'off' &&
      !firstRecordingStatus?.notification_sent
    ) {
      return setIsEnabled((prevIsEnabled) => ({ ...prevIsEnabled, [currentSite.id]: true }));
    }

    return setIsEnabled((prevIsEnabled) => ({ ...prevIsEnabled, [currentSite.id]: false }));
  }, [firstRecordingStatus, isInRecordingsPage, currentSite]);

  return {
    firstRecordingStatus,
    isLoading,
  };
};
